"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavMegaLvl3 = exports.NavMegaLvl2 = exports.NavHeader = exports.MobileMenuItem = exports.Body3 = exports.Body2 = exports.Body1 = exports.LabelOnForm = exports.IntroductoryText = exports.IntroOnImage = exports.MetaSmall = exports.MetaLarge = exports.Blockquote = exports.EyebrowSmall = exports.Eyebrow = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.h1Small = exports.h1Display = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_system_1 = require("styled-system");
exports.h1Display = styled_components_1.default.h1 `
  color: ${(props) => props.color || props.theme.palette.BW_0};
  font-size: ${(props) => props.theme.typography.size.m4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.l1}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    font-size: ${(props) => props.theme.typography.size.l2}px;
    line-height: ${(props) => props.theme.typography.lineHeight.l5}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: ${(props) => props.theme.typography.size.l3}px;
    line-height: ${(props) => props.theme.typography.lineHeight.l6}px;
  }

  ${styled_system_1.typography};
`;
exports.h1Small = styled_components_1.default.h1 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.m2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m5}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  ${styled_system_1.typography};
`;
exports.h1 = styled_components_1.default.h1 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.m4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.l1}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    font-size: ${(props) => props.theme.typography.size.l1}px;
    line-height: ${(props) => props.theme.typography.lineHeight.l2}px;
  }

  ${styled_system_1.typography};
`;
exports.h2 = styled_components_1.default.h2 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.m3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.l1}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  ${styled_system_1.typography};
`;
exports.h3 = styled_components_1.default.h3 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.m2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m5}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  ${styled_system_1.typography};
`;
exports.h4 = styled_components_1.default.h4 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.m1}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m3}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  ${styled_system_1.typography};
`;
exports.h5 = styled_components_1.default.h5 `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.s5}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.Eyebrow = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.BW_0};
  font-size: ${(props) => props.theme.typography.size.s3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  letter-spacing: ${props => props.theme.typography.letterSpacing.s1}rem;
  ${styled_system_1.typography};
`;
exports.EyebrowSmall = (0, styled_components_1.default)(exports.Eyebrow) `
  font-size: ${(props) => props.theme.typography.size.s2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m1}px;
  ${styled_system_1.typography};
`;
exports.Blockquote = styled_components_1.default.blockquote `
  color: ${(props) => props.color || props.theme.palette.BW_0};
  font-size: ${(props) => props.theme.typography.size.s4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.light};
  ${styled_system_1.typography};
`;
exports.MetaLarge = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.BW_0};
  font-size: ${(props) => props.theme.typography.size.s3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m1}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.MetaSmall = (0, styled_components_1.default)(exports.MetaLarge) `
  font-size: ${(props) => props.theme.typography.size.s2}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.IntroOnImage = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.BW_0};
  font-size: ${(props) => props.theme.typography.size.s5}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.IntroductoryText = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${(props) => props.theme.typography.size.m1}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m4}px;
  font-weight: ${(props) => props.theme.typography.weight.light};
  ${styled_system_1.typography};
`;
exports.LabelOnForm = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${(props) => props.theme.typography.size.s3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m1}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.Body1 = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${(props) => props.theme.typography.size.defaultSize}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.Body2 = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${(props) => props.theme.typography.size.s2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m6}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.Body3 = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${(props) => props.theme.typography.size.s1}px;
  line-height: ${(props) => props.theme.typography.lineHeight.s3}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.MobileMenuItem = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.s4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m2}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.NavHeader = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.s3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.s5}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.NavMegaLvl2 = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.s3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.m6}px;
  font-weight: ${(props) => props.theme.typography.weight.medium};
  ${styled_system_1.typography};
`;
exports.NavMegaLvl3 = styled_components_1.default.div `
  color: ${(props) => props.color || props.theme.palette.LIGHT_BLACK};
  font-size: ${(props) => props.theme.typography.size.s2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.s5}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${styled_system_1.typography};
`;
exports.default = {
    h1Display: exports.h1Display,
    h1: exports.h1,
    h2: exports.h2,
    h3: exports.h3,
    h4: exports.h4,
    h5: exports.h5,
    MetaLarge: exports.MetaLarge,
    MetaSmall: exports.MetaSmall,
    Eyebrow: exports.Eyebrow,
    EyebrowSmall: exports.EyebrowSmall,
    Blockquote: exports.Blockquote,
    LabelOnForm: exports.LabelOnForm,
    Body1: exports.Body1,
    Body2: exports.Body2,
    IntroductoryText: exports.IntroductoryText,
    MobileMenuItem: exports.MobileMenuItem,
    NavHeader: exports.NavHeader,
    NavMegaLvl2: exports.NavMegaLvl2,
    NavMegaLvl3: exports.NavMegaLvl3
};
